<template>
    <table class="table table-bordered table-striped table-vcenter dataTable" style="width: 100%;">
        <thead>
            <tr>
                <th v-if="!hide.includes('customer')">Customer</th>
                <th v-if="!hide.includes('address')">Address</th>
                <th v-if="!hide.includes('actions')">Actions</th>
            </tr>
        </thead>
        <tbody></tbody>
    </table>
</template>

<script>
import { buildColumns } from "@/helpers/build-columns";

export default {
    props: {
        ajaxUrl: String,
        hide: {
            type: Array,
            default: () => [],
            required: false,
        }
    },

    data() {
        return {
            columnDefinitions: {
                customer: {
                    name: 'customer.name',
                    orderable: false,
                    searchable: false,
                    render: function(data, type, row) {
                        return row.computed_customer;
                    }
                },
                address: {
                    name: 'address1',
                    render: function (data, type, row) {
                        return row.computed_address;
                    }
                },
                actions: {
                    data: 'actions',
                    name: 'actions',
                    searchable: false,
                    orderable: false,
                    width: '200px',
                }
            }
        }
    },

    mounted() {
        window.jQuery(this.$el).dataTable({
            processing: true,
            serverSide: true,
            pageLength: 25,
            lengthMenu: [25, 50, 100],
            ajax: {
                url: this.ajaxUrl,
            },
            order: [[0, 'asc']],
            columns: buildColumns(this.columnDefinitions, this.hide),
        });
    },
};
</script>
